import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RelationshipStoreEffects } from './effects';
import { RelationshipReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Relationship', RelationshipReducer), EffectsModule.forFeature([RelationshipStoreEffects])],
  providers: [RelationshipStoreEffects]
})
export class RelationshipStoreModule {
  Relationship: any;
}
